import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Typography as material_Typography } from "@mui/material";
import { clsx } from "clsx";
import { EXPANDABLE_CELL_NESTED_TEXT_CONTENT_CLASS_NAME } from "../DataTable/index.js";
const Typography_Typography = /*#__PURE__*/ forwardRef(function({ wrapInExpandableTableCell, className: classNameProp, ...props }, ref) {
    const className = clsx(classNameProp, wrapInExpandableTableCell && EXPANDABLE_CELL_NESTED_TEXT_CONTENT_CLASS_NAME);
    if (void 0 === props.component) {
        if (void 0 === props.variant) return /*#__PURE__*/ jsx(material_Typography, {
            component: "div",
            ref: ref,
            className: className,
            ...props
        });
        if (props.variant?.startsWith('body')) return /*#__PURE__*/ jsx(material_Typography, {
            component: "div",
            ref: ref,
            className: className,
            ...props
        });
        if (props.variant && [
            'caption',
            'code',
            'button',
            'overline1',
            'overline2'
        ].includes(props.variant)) return /*#__PURE__*/ jsx(material_Typography, {
            component: "span",
            ref: ref,
            className: className,
            ...props
        });
    }
    return /*#__PURE__*/ jsx(material_Typography, {
        ref: ref,
        className: className,
        ...props
    });
});
export { Typography_Typography as Typography };

//# sourceMappingURL=Typography.js.map